import React from 'react';

const MaxBoxes = ({ numRows, numColumns, numColors }) => {
  const rowCount = Number(numRows);
  const colCount = Number(numColumns);
  const colorCount = Number(numColors);

  const rows = rowCount;
  const columns = colCount;
  const colors = colorCount;
  const COLOR_ARRAY = ['red', 'green', 'blue', 'orange', 'gray', 'black', 'yellow', 'cyan', 'purple', 'violet', 'lime', 'magenta', 'pink', 'brown', 'olive', 'white', 'aquamarine', 'maroon', 'platinum', 'mint'];

  // const generateRandomColor = () => {
  //   const red = Math.floor(Math.random() * 256);
  //   const green = Math.floor(Math.random() * 256);
  //   const blue = Math.floor(Math.random() * 256);

  //   return `rgb(${red},${green},${blue})`;
  // }

  // For generating the random color as per given input
  const colorArray = new Array(colors);

  for (let i = 0; i < colorArray.length; i++) {
    colorArray[i] = COLOR_ARRAY[i]; // generateRandomColor();
  }

  // For generating the matrix with color as per given input
  const matrix = new Array(rows);
  for (let i = 0; i < matrix.length; i++) {
    matrix[i] = new Array(columns);
    for (let j = 0; j < matrix[i].length; j++) {
      matrix[i][j] = colorArray[Math.floor(Math.random() * colorArray.length)];
    }
  }

  const colorLengths = {};

  const isValid = (row, col) => {
    return row >= 0 && row < rows && col >= 0 && col < columns;
  }

  const dfs = (row, col, color, visitedMatrix) => {
    if (!isValid(row, col) || visitedMatrix[row][col] || matrix[row][col] !== color) {
      return 0;
    }

    visitedMatrix[row][col] = true;

    let count = 1;
    count += dfs(row + 1, col, color, visitedMatrix); // Down neighbor
    count += dfs(row - 1, col, color, visitedMatrix); // Up neighbor
    count += dfs(row, col + 1, color, visitedMatrix); // Right neighbor
    count += dfs(row, col - 1, color, visitedMatrix); // Left neighbor

    return count;
  }

  const visitedMatrix = new Array(rows);
  for (let i = 0; i < visitedMatrix.length; i++) {
    visitedMatrix[i] = new Array(columns).fill(false);
  }

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < columns; j++) {
      const color = matrix[i][j];
      if (!colorLengths[color]) {
        colorLengths[color] = 0;
      }

      if (!visitedMatrix[i][j]) {
        const count = dfs(i, j, color, visitedMatrix);
        colorLengths[color] = Math.max(colorLengths[color], count);
      }
    }
  }


  // Find the maximum colors in matrix

  let maxLength = 0;
  let maxColor = '';

  Object.entries(colorLengths).forEach(([color, length]) => {
    if (length > maxLength) {
      maxLength = length;
      maxColor = color;
    }
  });

  return (
    <>
      <div className='container'>
        <div>
          <h6>{`Number of cells on the width: ${rows},`}</h6>

          <h6>{`Number of cells on the height: ${columns},`}</h6>

          {maxColor && <h6>Result: The biggest area contains <span style={{ color: 'blue' }}>{`${maxLength}`}</span> cells with <span style={{ color: 'blue' }}>{`${maxColor}`}</span> color.</h6>}

        </div>

        <div>
          {matrix.map((row, rowIndex) => (
            <div key={rowIndex} style={{ display: 'flex' }}>
              {row.map((color, columnIndex) => (
                <div
                  key={`${rowIndex}-${columnIndex}`}
                  style={{
                    backgroundColor: color,
                    width: '50px',
                    height: '50px',
                  }}
                ></div>
              ))}
            </div>
          ))}

        </div>
      </div>
    </>
  );
};

export default MaxBoxes;

